import { render } from "./SecondSidebarLink.vue?vue&type=template&id=4f507538&scoped=true"
import script from "./SecondSidebarLink.vue?vue&type=script&lang=js"
export * from "./SecondSidebarLink.vue?vue&type=script&lang=js"

import "./SecondSidebarLink.vue?vue&type=style&index=0&id=4f507538&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f507538"]])

export default __exports__